import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { CustomerProfileLanding } from "./component";
import { getRewardsAccounts } from "../../modules/rewards/reducer";
import { IStoreState } from "../../reducers/types";
import { getPaymentMethods } from "../../modules/preferences/reducer";
import { listPaymentMethods } from "../../modules/preferences/actions/actions";
import { fetchRewardsAccounts } from "../../modules/rewards/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  rewardsAccounts: getRewardsAccounts(state),
  paymentMethods: getPaymentMethods(state),
});

const mapDispatchToProps = {
  listPaymentMethods,
  fetchRewardsAccounts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CustomerProfileLandingConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCustomerProfileLanding = connector(
  withRouter(CustomerProfileLanding),
);
